module.exports = __webpack_public_path__ + "imgs/about.0c67f5c7d37b0bbe35fdbf1a90da1084.svg";